<template>
  <div class="body-card-facility">
    <div class="image-container">
      <img
        v-if="image"
        @error="handleImageError()"
        class="image"
        :src="image"
        :alt="image"
      />
    </div>
    <div class="content" style="cursor: pointer">
      <p class="facility-name c-bold-text  m-0  fw-600 c-caption">
        {{ title }}
      </p>
      <div class="d-flex algin-items-center  m-0">
        <img class="mr-10" :src="bg.icon_address1" alt="" />
        <p class="c-tiny des-facility mt-3 m-0">
          {{ location }}
        </p>
      </div>

      <div class="flex algin-items-center justify-content-between">
        <p class="c-tiny m-0 c-medium-text">{{ holes_amount }} holes</p>
        <div class="">
          <img
            v-for="(item, index) in [1, 2, 3, 4, 5]"
            :key="index"
            class="ml-1"
            :src="item > rating ? iconStart : iconStart1"
            alt="icon start"
          />
          <span style="color: #333333; font-weight:200" class="ml-5 c-tiny"
            >({{ reviews_count }} reviews)</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, convertDate, formatNumber } from "@/utils/formatData";
import { getBackGround } from "@/utils/wapAuth";

export default {
  bodyClass: "card-facilities",
  components: {},
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      default: "Sky Lake Golf & Resort"
    },
    location: {
      default: ""
    },
    holes_amount: {
      default: ""
    },
    reviews_count: {
      default: ""
    },
    image: {
      default: ""
    },
    id: {
      default: ""
    },

    rating: {
      default: 4
    }
  },
  watch: {
    objectData(val) {}
  },
  data() {
    return {
      bg: getBackGround(),
      type: null,
      iconStart1: require("@/assets/img/v3/icon/icon_star_1.svg"),
      iconStart: require("@/assets/img/v3/icon/icon_star.svg"),
      icons: {},
      slickOptions: {
        dotsClass: "custom-dot-class",
        dots: true,
        arrows: false,
        autoplaySpeed: 2000,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    };
  },
  computed: {},
  methods: {
    formatCurrency,
    convertDate,
    formatNumber,
    handleImageError() {
      return "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png";
    }
  }
};
</script>
<style lang="scss">
.carousel-review-facility {
  .el-carousel__button {
    width: 6px;
    height: 6px;
    border-radius: 100%;
    background: #00000033;
    opacity: 1 !important;
  }
  .el-carousel__indicator.is-active button {
    opacity: 1;
    background: v-bind("bg.c_inherit_text");
  }
  .el-carousel__indicator--horizontal {
    padding: 5px 4px;
  }
}
.slick-review-facility {
  .slick-slide {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .custom-dot-class {
    color: red;
    z-index: 1000 !important;
  }
}
</style>

<style scoped lang="scss">
.mr-10 {
  margin-right: 10px;
}

.content {
  padding: 15px 20px;
}

.full-width {
  width: 100%;
}

.facility-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.icon-sale-container {
  position: absolute;
  top: 10px;
}

.image-container {
  position: relative;
  overflow: hidden;
  height: 205px;
  .image {
    border-radius: 8px;
    user-drag: none; /* Safari */
    -webkit-user-drag: none; /* Chrome, Safari, Edge */
    -moz-user-select: none; /* Firefox */
    user-select: none; /* Ngăn chọn ảnh */
    pointer-events: auto; /* Vẫn cho click */
    width: 100% !important;
    height: 205px !important;

    object-fit: cover;
    object-position: top;
  }
}
.body-card-facility {
  background-color: #ffff;
  position: relative;
  overflow: hidden;
}

.text-left {
  width: 100%;
  text-align: left;
}

.mb-0 {
  margin-bottom: 0;
}
.facility-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}
.des-facility {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Số dòng giới hạn */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  line-height: 20px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .image-container {
    .image {
      border-radius: 0px;
    }
  }
}
@media screen and (min-width: 0px) and (max-width: 480px) {
  .body-card-facility {
    position: relative;
    overflow: hidden;
  }
}
</style>
